import React from 'react';
import { ServerIcon, CheckCircle2Icon, ArrowRightIcon, ExternalLinkIcon } from 'lucide-react';
import { StatusBadge } from '../components/ui/StatusBadge';
export function ProviderSelectionPage() {
  return <div className="flex flex-col pb-12" data-id="element-1072">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4" data-id="element-1073">
        <div data-id="element-1074">
          <h1 className="text-3xl font-bold mb-1 flex items-center gap-2" data-id="element-1075">
            <ServerIcon className="w-8 h-8 text-primary" data-id="element-1076" />
            Payment Providers
          </h1>
          <p className="text-muted-foreground" data-id="element-1077">
            Manage your connected payment gateways and merchant of record
            providers.
          </p>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-1078">
        {/* Stripe - Connected */}
        <div className="bg-card border-2 border-primary rounded-xl p-6 shadow-sm relative overflow-hidden" data-id="element-1079">
          <div className="absolute top-0 right-0 bg-primary text-primary-foreground text-[10px] font-bold px-3 py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-1080">
            Active
          </div>
          <div className="flex items-center gap-4 mb-6" data-id="element-1081">
            <div className="w-12 h-12 bg-[#635BFF] rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-inner" data-id="element-1082">
              S
            </div>
            <div data-id="element-1083">
              <h2 className="text-xl font-bold" data-id="element-1084">Stripe</h2>
              <p className="text-sm text-muted-foreground" data-id="element-1085">Payment Gateway</p>
            </div>
          </div>

          <div className="space-y-3 mb-6" data-id="element-1086">
            <div className="flex items-center gap-2 text-sm" data-id="element-1087">
              <CheckCircle2Icon className="w-4 h-4 text-pk-success" data-id="element-1088" />
              <span data-id="element-1089">Subscriptions & One-time</span>
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-1090">
              <CheckCircle2Icon className="w-4 h-4 text-pk-success" data-id="element-1091" />
              <span data-id="element-1092">Usage-based billing</span>
            </div>
            <div className="flex items-center gap-2 text-sm" data-id="element-1093">
              <CheckCircle2Icon className="w-4 h-4 text-pk-success" data-id="element-1094" />
              <span data-id="element-1095">Stripe Tax support</span>
            </div>
          </div>

          <div className="pt-4 border-t border-border flex justify-between items-center" data-id="element-1096">
            <StatusBadge status="success" label="Connected" data-id="element-1097" />
            <button className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1" data-id="element-1098">
              Manage <ExternalLinkIcon className="w-3 h-3" data-id="element-1099" />
            </button>
          </div>
        </div>

        {/* Paddle - Coming Soon */}
        <div className="bg-pk-surface border border-border rounded-xl p-6 opacity-70 hover:opacity-100 transition-opacity" data-id="element-1100">
          <div className="flex items-center gap-4 mb-6" data-id="element-1101">
            <div className="w-12 h-12 bg-border rounded-lg flex items-center justify-center text-foreground font-bold text-xl" data-id="element-1102">
              P
            </div>
            <div data-id="element-1103">
              <h2 className="text-xl font-bold" data-id="element-1104">Paddle</h2>
              <p className="text-sm text-muted-foreground" data-id="element-1105">
                Merchant of Record
              </p>
            </div>
          </div>

          <div className="space-y-3 mb-6" data-id="element-1106">
            <div className="flex items-center gap-2 text-sm text-muted-foreground" data-id="element-1107">
              <CheckCircle2Icon className="w-4 h-4" data-id="element-1108" />
              <span data-id="element-1109">Global Tax Compliance</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground" data-id="element-1110">
              <CheckCircle2Icon className="w-4 h-4" data-id="element-1111" />
              <span data-id="element-1112">B2B & B2C Invoicing</span>
            </div>
          </div>

          <div className="pt-4 border-t border-border" data-id="element-1113">
            <span className="inline-block px-2.5 py-1 bg-muted text-muted-foreground text-xs font-medium rounded-md" data-id="element-1114">
              Coming Q3 2024
            </span>
          </div>
        </div>

        {/* LemonSqueezy - Coming Soon */}
        <div className="bg-pk-surface border border-border rounded-xl p-6 opacity-70 hover:opacity-100 transition-opacity" data-id="element-1115">
          <div className="flex items-center gap-4 mb-6" data-id="element-1116">
            <div className="w-12 h-12 bg-border rounded-lg flex items-center justify-center text-[#7047EB] font-bold text-xl" data-id="element-1117">
              L
            </div>
            <div data-id="element-1118">
              <h2 className="text-xl font-bold" data-id="element-1119">LemonSqueezy</h2>
              <p className="text-sm text-muted-foreground" data-id="element-1120">
                Merchant of Record
              </p>
            </div>
          </div>

          <div className="space-y-3 mb-6" data-id="element-1121">
            <div className="flex items-center gap-2 text-sm text-muted-foreground" data-id="element-1122">
              <CheckCircle2Icon className="w-4 h-4" data-id="element-1123" />
              <span data-id="element-1124">Software Licensing</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-muted-foreground" data-id="element-1125">
              <CheckCircle2Icon className="w-4 h-4" data-id="element-1126" />
              <span data-id="element-1127">Affiliate Management</span>
            </div>
          </div>

          <div className="pt-4 border-t border-border" data-id="element-1128">
            <span className="inline-block px-2.5 py-1 bg-muted text-muted-foreground text-xs font-medium rounded-md" data-id="element-1129">
              Coming Q4 2024
            </span>
          </div>
        </div>
      </div>

      {/* Comparison Table */}
      <div className="bg-card border border-border rounded-xl shadow-sm overflow-hidden" data-id="element-1130">
        <div className="px-6 py-4 border-b border-border" data-id="element-1131">
          <h3 className="font-bold text-lg" data-id="element-1132">Capabilities Comparison</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-1133">
          <table className="w-full text-sm text-left" data-id="element-1134">
            <thead className="text-xs text-muted-foreground uppercase bg-muted/50 border-b border-border" data-id="element-1135">
              <tr data-id="element-1136">
                <th className="px-6 py-4 font-medium" data-id="element-1137">Feature</th>
                <th className="px-6 py-4 font-medium" data-id="element-1138">Stripe</th>
                <th className="px-6 py-4 font-medium" data-id="element-1139">Paddle</th>
                <th className="px-6 py-4 font-medium" data-id="element-1140">LemonSqueezy</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-1141">
              <tr className="hover:bg-muted/30 transition-colors" data-id="element-1142">
                <td className="px-6 py-4 font-medium" data-id="element-1143">Model</td>
                <td className="px-6 py-4" data-id="element-1144">Payment Gateway</td>
                <td className="px-6 py-4" data-id="element-1145">Merchant of Record</td>
                <td className="px-6 py-4" data-id="element-1146">Merchant of Record</td>
              </tr>
              <tr className="hover:bg-muted/30 transition-colors" data-id="element-1147">
                <td className="px-6 py-4 font-medium" data-id="element-1148">Tax Liability</td>
                <td className="px-6 py-4 text-muted-foreground" data-id="element-1149">
                  You (with Stripe Tax)
                </td>
                <td className="px-6 py-4 text-pk-success font-medium" data-id="element-1150">
                  Provider
                </td>
                <td className="px-6 py-4 text-pk-success font-medium" data-id="element-1151">
                  Provider
                </td>
              </tr>
              <tr className="hover:bg-muted/30 transition-colors" data-id="element-1152">
                <td className="px-6 py-4 font-medium" data-id="element-1153">Usage-based Billing</td>
                <td className="px-6 py-4 text-pk-success font-medium" data-id="element-1154">
                  Advanced
                </td>
                <td className="px-6 py-4 text-muted-foreground" data-id="element-1155">Basic</td>
                <td className="px-6 py-4 text-muted-foreground" data-id="element-1156">No</td>
              </tr>
              <tr className="hover:bg-muted/30 transition-colors" data-id="element-1157">
                <td className="px-6 py-4 font-medium" data-id="element-1158">Custom Checkout UI</td>
                <td className="px-6 py-4 text-pk-success font-medium" data-id="element-1159">
                  Elements / API
                </td>
                <td className="px-6 py-4 text-muted-foreground" data-id="element-1160">
                  Overlay only
                </td>
                <td className="px-6 py-4 text-muted-foreground" data-id="element-1161">Hosted only</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}